import { createRoute } from '@tanstack/react-router';
import type { EzyModule } from '../module';
import { MailView } from './MailView';

// Mint-Booking-Msg: mở thư info@ theo Message-ID (task / thông báo trỏ tới). Không có nav riêng — vào từ Booking.
const bookingMsg: EzyModule = {
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/booking/msg', component: MailView }),
    createRoute({ getParentRoute: () => parent, path: '/booking/msg/$messageId', component: MailView }),
  ],
};
export default bookingMsg;
